import React from 'react';

export default function Hero() {
    return(
        <div className="banner-img mb-3">

        </div>
    )
};